import {
  Platform,
  Pressable,
  SectionList,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import BaseScreen from "../BaseScreen";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  black,
  color_333333,
  color_666666,
  color_F1F1F1,
  primary50,
  white,
} from "../../assets/style/colors";
import { useStore } from "../../store/UserStore";
import { useAppNavigation } from "../navigation";
import { getAvatarByUser, userListByLetter } from "../../utils/utils";
import { Badge } from "../../components/Badge";
import { LeftView } from "../Chat/CListItem";
import { User } from "../../../imsdk/db/t_user";
import { getUserName } from "../Chat/chat-helper";
import {
  Str_ContactBlackTip,
  Str_ContactFriendTip,
  Str_GroupChat,
  Str_Label,
  Str_MassSendingAssistant,
  Str_NewFriendInvitation,
  Str_Search,
} from "../../language/string_res";
import { Letter } from "../../components/Letter";
import getItemLayout from "../GetItemLayout";
import { useTranslation } from "react-i18next";
import { getMsgAssistant } from "../../store/token";
import { MQEventCallBack } from "../../../imsdk/api/mq";
import * as ImSdk from "../../../imsdk/api";
import { RefreshControl } from "react-native-gesture-handler";
import globalEventBus from "../../utils/EventBus";
import NewFriendIcon from "../../assets/svg/icon_invite.svg";
import GroupChatIcon from "../../assets/svg/icon_group_chat.svg";
import LabelIcon from "../../assets/svg/icon_label.svg";
import SearchIcon from "../../assets/svg/icon_search.svg";
import AssistantIcon from "../../assets/svg/icon_assistant.svg";
import { AddMenu } from "../Chat/components/AddMenu";

interface HeadItem {
  title: string;
  icon?: React.ReactNode;
}

export type ContactData = {
  title: string;
  data: User[];
};

const ContactScreen = () => {
  useTranslation(); //防止切换语言的时候页面不更新
  const navigation = useAppNavigation();
  const sectionRef = useRef<SectionList<User, ContactData>>(null);
  const [msgAssistant, setMsgAssistant] = useState(getMsgAssistant());
  const [refreshing, setRefreshing] = useState(false);
  const { dispatch } = useStore();
  const headSections: HeadItem[] = [
    {
      title: Str_NewFriendInvitation,
      icon: <NewFriendIcon width={50} height={50} />,
    },
    { title: Str_GroupChat, icon: <GroupChatIcon width={50} height={50} /> },
    { title: Str_Label, icon: <LabelIcon width={50} height={50} /> },
  ];

  const { state } = useStore();
  const im = ImSdk.getInstance();
  const { friendNum, blackNum, section } = useMemo(() => {
    const c = state?.contactList ?? [];
    const b = state?.contactBlackList ?? [];
    const result = new Set<User>();
    c.forEach((value) => {
      const b1 = value.status !== "deleted";
      const b2 = b.some((item) => item.uid === value.uid);
      if (b1 && !b2) {
        result.add(value);
      }
    });
    const users = Array.from(result);
    const sectionResult = userListByLetter(users);
    return {
      friendNum: users.length,
      blackNum: state?.contactBlackList?.length ?? 0,
      section: sectionResult,
    };
  }, [state?.contactList, state?.contactBlackList, state?.dataVersion]);

  useEffect(() => {
    im.on("user_permission", userPermissionCallback);
    return () => {
      im.off("user_permission", userPermissionCallback);
    };
  }, []);

  function refreshContact() {
    const request1 = ImSdk.getInstance().GetRemoteContact();
    const request2 = ImSdk.getInstance().GetRemoteFriendBlack();
    Promise.all([request1, request2]).then(([res1, res2]) => {
      setRefreshing(false);
      const contacts = res1.users ?? [];
      const blacks = res2.blacks ?? [];
      if (contacts.length > 0 && blacks.length > 0) {
        dispatch({
          type: "REPLACE_CONTACT_LIST",
          payload: { users: contacts, black: blacks },
        });
      }
    });
  }

  const onRefresh = () => {
    setRefreshing(true);
    refreshContact();
  };

  const userPermissionCallback: MQEventCallBack = async (res) => {
    if (res.type === "user_permission") {
      const data = res.data.user_permission;
      if (data && data.msgAssistant !== undefined) {
        setMsgAssistant(data.msgAssistant);
      }
    }
  };

  const ListFooterComponent = () => (
    <View style={{ alignItems: "center", paddingVertical: 22 }}>
      {friendNum > 0 || blackNum > 0 ? (
        <Text style={{ color: color_333333 }}>
          {friendNum}
          {Str_ContactFriendTip}
          {blackNum}
          {Str_ContactBlackTip}
        </Text>
      ) : null}
    </View>
  );
  const SectionHeader = ({ section: { title } }: { section: ContactData }) => (
    <View
      style={{
        height: 24,
        justifyContent: "center",
        backgroundColor: white,
        marginTop: 18,
      }}
    >
      <Text style={styles.header}>{title}</Text>
    </View>
  );
  const friendApply = state?.friendApply ?? 0;
  if (msgAssistant === 1) {
    headSections.push({
      title: Str_MassSendingAssistant,
      icon: <AssistantIcon width={50} height={50} />,
    });
  }
  const ListHeaderComponent = () => {
    return (
      <View>
        {headSections.map((section, index) => {
          return (
            <TouchableOpacity
              key={index.toString()}
              onPress={() => onHeadClick(section, index)}
              activeOpacity={1}
              style={[styles.headerItem, index > 0 && { marginTop: 16 }]}
            >
              {section.icon}
              <Text style={styles.itemTextSection}>{section.title}</Text>
              <View>
                <Badge
                  style={{ marginStart: 8 }}
                  visible={index == 0 && friendApply > 0}
                  children={friendApply}
                />
              </View>
            </TouchableOpacity>
          );
        })}
      </View>
    );
  };

  const onClick = (item: User) => {
    // 在 Web 环境下，使用统一的事件
    if (Platform.OS === "web") {
      globalEventBus.emit("ShowWebDetail", {
        screenName: "ContactInfo",
        params: {
          current: item,
          type: "FRIEND",
          isTab: true,
        },
      });
    } else {
      navigation.navigate("ContactInfo", {
        current: item,
        type: "FRIEND",
      });
    }
  };
  const onHeadClick = (item: HeadItem, index: number) => {
    const screens = [
      "FriendApplyList",
      "GroupList",
      "ContactsLabelScreen",
      "MassSendingAssistant",
    ];
    const screenName = screens[index];

    if (Platform.OS === "web") {
      // Web 环境下使用统一的事件
      globalEventBus.emit("ShowWebDetail", {
        screenName,
        params: {},
      });
    } else {
      // 移动端使用原来的导航
      navigation.navigate(screenName as any);
    }
  };

  const renderItem = ({ item }: { item: User }) => {
    return (
      <Pressable onPress={() => onClick(item)} style={[styles.item]}>
        <LeftView left={getAvatarByUser(item)} size={50} />
        <Text numberOfLines={1} ellipsizeMode={"tail"} style={styles.itemText}>
          {getUserName(item)}
        </Text>
        <View style={styles.itemLine} />
      </Pressable>
    );
  };

  const HeaderComponent = () => (
    <View style={styles.searchContainer} key="ContactHeader">
      <Pressable
        onPress={() => navigation.navigate("ChatSearch")}
        style={[styles.search, { flex: 1 }]}
      >
        <SearchIcon width={20} height={20} />
        <Text style={styles.searchText}>{Str_Search}</Text>
      </Pressable>
      <AddMenu />
    </View>
  )

  return (
    <BaseScreen styles={{ backgroundColor: "white" }}>
      <HeaderComponent/>
      <View
        style={{
          flex: 1,
          overflow: "visible",
          flexDirection: "row",
          marginTop: 15,
        }}
      >
        <SectionList
          sections={section}
          ref={sectionRef}
          style={{ marginRight: 30 }}
          showsVerticalScrollIndicator={false}
          keyExtractor={(item, index) => index.toString()}
          renderItem={renderItem}
          renderSectionHeader={SectionHeader}
          ListEmptyComponent={() => {
            return (
              <View style={{ padding: 20, alignItems: "center" }}>
                <Text style={{ color: color_666666 }}>暂无联系人</Text>
              </View>
            );
          }}
          getItemLayout={getItemLayout({
            getItemHeight: 55,
            getSectionHeaderHeight: 24,
            getListHeaderHeight: headSections.length * 55,
          })}
          stickySectionHeadersEnabled
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
          ListHeaderComponent={<ListHeaderComponent />}
          ListFooterComponent={<ListFooterComponent />}
        />
        <Letter
          section={section}
          scrollToLocation={(index) =>
            sectionRef.current?.scrollToLocation({
              animated: true,
              itemIndex: 0,
              sectionIndex: index,
            })
          }
        />
      </View>
    </BaseScreen>
  );
};

export default ContactScreen;

const styles = StyleSheet.create({
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    marginTop: 16,
    marginBottom: 12,
  },
  search: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    height: 48,
    borderRadius: 24,
    marginRight: 12,
    backgroundColor: color_F1F1F1,
    paddingHorizontal: 16,
    flex: 1,
  },
  searchText: {
    fontSize: 15,
    color: color_666666,
    marginStart: 10,
    textAlignVertical: "center",
    flex: 1,
  },
  headerItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: white,
    borderRadius: 12,
    marginHorizontal: 16,
  },
  item: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: white,
  },
  header: {
    fontSize: 14,
    marginStart: 16,
    color: "#666666",
    fontWeight: "600",
  },
  itemText: {
    fontSize: 16,
    flex: 1,
    color: color_333333,
    fontWeight: "500",
    marginLeft: 12,
  },
  itemTextSection: {
    fontSize: 16,
    marginStart: 12,
    flex: 1,
    color: color_333333,
    fontWeight: "500",
  },
  itemLine: {
    position: "absolute",
    bottom: 0,
    start: 16,
    height: 0.5,
    end: 16,
    backgroundColor: color_F1F1F1,
  },
});
